export class GdsgRegionStats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "points",
            "baseName": "points",
            "type": "Array<GdsgRegionStatsPoint>",
            "format": ""
        },
        {
            "name": "totalStorageBytes",
            "baseName": "totalStorageBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "storageObservedAtMs",
            "baseName": "storageObservedAtMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "membersProcessedTotal",
            "baseName": "membersProcessedTotal",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "failuresTotal",
            "baseName": "failuresTotal",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "replicationLagP95MsMax",
            "baseName": "replicationLagP95MsMax",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "putAckToBackupLagP95MsMax",
            "baseName": "putAckToBackupLagP95MsMax",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sampleError",
            "baseName": "sampleError",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataLossTotal",
            "baseName": "dataLossTotal",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "dataLossSampleError",
            "baseName": "dataLossSampleError",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GdsgRegionStats.attributeTypeMap;
    }
    constructor() {
    }
}
